import React, { useEffect, useState } from "react";
import { DashboardLayout } from "@/components/Layout/DashboardLayout";
import api from "@/lib/api";
import { adminNavItems } from "./_nav";
import { useLang } from "@/contexts/LanguageContext";
import { Star } from "lucide-react";

export default function AdminRestaurants() {
  const { t } = useLang();
  const [rs, setRs] = useState([]);
  const load = () => api.get("/admin/restaurants").then(r => setRs(r.data));
  useEffect(() => { load(); }, []);

  const toggleFeatured = async (id, current) => {
    await api.patch(`/admin/restaurants/${id}/feature`, null, { params: { featured: !current } });
    load();
  };

  return (
    <DashboardLayout items={adminNavItems(t)} title={t("restaurants")}>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3">
        {rs.map(r => (
          <div key={r.id} className="so-card overflow-hidden" data-testid={`admin-restaurant-${r.id}`}>
            <div className="h-32 bg-gray-200 dark:bg-gray-800 overflow-hidden">
              <img src={r.image_url} alt={r.name} className="w-full h-full object-cover" />
            </div>
            <div className="p-4">
              <div className="font-bold">{r.name}</div>
              <div className="text-xs text-[var(--so-text-soft)]">{r.cuisine}</div>
              <div className="mt-2 flex items-center gap-2 text-xs">
                <span className="flex items-center gap-1"><Star className="w-3 h-3 fill-amber-400 text-amber-400" /> {r.rating}</span>
                <span className="text-[var(--so-text-soft)]">· {r.review_count} reviews</span>
              </div>
              <div className="mt-3 flex items-center gap-2">
                <span className="text-[10px] font-bold uppercase px-2 py-0.5 rounded-full bg-[var(--so-orange)]/10 text-[var(--so-orange)]">{r.subscription_plan}</span>
                <button onClick={() => toggleFeatured(r.id, r.is_featured)} data-testid={`feature-${r.id}`} className={`text-[10px] font-bold uppercase px-2 py-0.5 rounded-full ${r.is_featured ? "bg-emerald-500/10 text-emerald-600" : "bg-gray-500/10 text-[var(--so-text-soft)]"}`}>
                  {r.is_featured ? "Featured" : "Make featured"}
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </DashboardLayout>
  );
}
